import { REGIONAL_LOCALES } from "./regional-locales.mjs";

/**
 * Release policy for the four 2026-08 SEO guide/comparison pages.
 *
 * This is intentionally separate from the storefront locale configuration:
 * every other route and content tool continues to use all active locales.
 */
/** @typedef {"de" | "en" | "es" | "fr" | "it" | "pt-br"} SeoContentReleaseLocale */

/** @type {readonly SeoContentReleaseLocale[]} */
export const SEO_CONTENT_RELEASE_LOCALES = Object.freeze(["de", "en", "es", "fr", "it", "pt-br"]);

export const SEO_CONTENT_RELEASE_PAGES = Object.freeze([
	Object.freeze({ kind: "guide", slug: "pt-141-leitfaden" }),
	Object.freeze({ kind: "guide", slug: "vip-peptid-leitfaden" }),
	Object.freeze({ kind: "comparison", slug: "cagrilintide-vs-retatrutide" }),
	Object.freeze({ kind: "comparison", slug: "melanotan-1-vs-melanotan-2" }),
]);

const RELEASE_SLUGS = new Set(SEO_CONTENT_RELEASE_PAGES.map(({ slug }) => slug));
const RELEASE_LOCALES = new Set(SEO_CONTENT_RELEASE_LOCALES);

export function isSeoContentReleasePage(slug) {
	return RELEASE_SLUGS.has(slug);
}

export function getSeoContentReleaseLocales(slug) {
	return isSeoContentReleasePage(slug) ? SEO_CONTENT_RELEASE_LOCALES : null;
}

/**
 * Whether a locale may render a release page. A regional locale answers for its base
 * (es-mx → es): it renders the base text and canonicalises to the base page, so the locale list
 * of `getSeoContentReleaseLocales` (cluster, sitemap, feed) never names it.
 */
export function isSeoContentReleaseLocale(slug, locale) {
	const releaseLocale = Object.hasOwn(REGIONAL_LOCALES, locale) ? REGIONAL_LOCALES[locale].base : locale;
	return !isSeoContentReleasePage(slug) || RELEASE_LOCALES.has(releaseLocale);
}
